import { useState } from "react";
import { Check, Pencil, Trash2, X } from "lucide-react";

export function useConfirmDelete(timeoutMs = 3000) {
  const [confirmId, setConfirmId] = useState(null);
  const ask = (id) => {
    setConfirmId(id);
    setTimeout(() => setConfirmId((c) => (c === id ? null : c)), timeoutMs);
  };
  return { confirmId, ask, clear: () => setConfirmId(null) };
}

function RenameForm({ album, onSave, onCancel }) {
  const [value, setValue] = useState(album.name);
  return (
    <div className="flex items-center gap-1.5">
      <input
        autoFocus
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && onSave(value)}
        data-testid={`album-rename-input-${album.id}`}
        className="min-w-0 flex-1 rounded-lg border border-gold/40 px-2 py-1 text-sm outline-none focus:border-gold"
      />
      <button onClick={() => onSave(value)} data-testid={`album-rename-save-${album.id}`} aria-label="Save name" className="p-1 text-green-700 hover:text-green-900">
        <Check className="h-4 w-4" />
      </button>
      <button onClick={onCancel} aria-label="Cancel rename" className="p-1 text-plum/50 hover:text-plum">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}

export function AlbumItem({ album: a, selected, renaming, confirmDelete, onSelect, onStartRename, onCancelRename, onRename, onAskDelete, onDelete }) {
  return (
    <li
      data-testid={`album-item-${a.id}`}
      className={`rounded-xl border px-3 py-2.5 transition-all ${selected ? "border-gold bg-rose/70 shadow-sm" : "border-transparent bg-white hover:border-gold/40"}`}
    >
      {renaming ? (
        <RenameForm album={a} onSave={onRename} onCancel={onCancelRename} />
      ) : (
        <div className="flex items-center justify-between gap-2">
          <button onClick={onSelect} className="min-w-0 flex-1 text-left" data-testid={`album-select-${a.id}`}>
            <span className="block truncate text-sm font-medium text-wine">{a.name}</span>
            <span className="text-xs text-plum/50">{a.photos.length} {a.photos.length === 1 ? "photo" : "photos"}</span>
          </button>
          <div className="flex shrink-0 items-center gap-0.5">
            <button
              onClick={onStartRename}
              aria-label={`Rename ${a.name}`}
              data-testid={`album-rename-button-${a.id}`}
              className="rounded-lg p-1.5 text-plum/50 transition-colors hover:bg-rose hover:text-burgundy"
            >
              <Pencil className="h-3.5 w-3.5" />
            </button>
            {confirmDelete ? (
              <button onClick={onDelete} data-testid={`album-delete-confirm-${a.id}`} className="rounded-lg bg-red-600 px-2 py-1 text-[10px] font-semibold uppercase text-white">
                Sure?
              </button>
            ) : (
              <button
                onClick={onAskDelete}
                aria-label={`Delete ${a.name}`}
                data-testid={`album-delete-button-${a.id}`}
                className="rounded-lg p-1.5 text-plum/50 transition-colors hover:bg-red-50 hover:text-red-600"
              >
                <Trash2 className="h-3.5 w-3.5" />
              </button>
            )}
          </div>
        </div>
      )}
    </li>
  );
}
